import { api, config } from '../../../helpers/api';
import { generatePath } from 'react-router-dom';

export async function getVerificationCode({ phoneNumber }) {
  return await api.post(
    generatePath('/otp/'),
    undefined,
    config('json', {
      phone_number: phoneNumber,
      otp_type: 'change_password'
    })
  );
}

export async function verifyCode({ phoneNumber, verificationCode }) {
  return await api.post(
    generatePath('/otp/check'),
    undefined,
    config('json', {
      phone_number: phoneNumber,
      verification_code: verificationCode
    })
  );
}

export async function changePassword({ accessToken, password }) {
  return await api.post(
    generatePath('/user/change_forgotten_password'),
    {
      new_password: password
    },
    {
      timeout: 20000,

      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
        'access-token': accessToken
      }
    }
  );
}
